import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../blogs/admin_blog.css";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";

const addTestimonialEndpoint = ApiEndpoints.VideoTestimonial.testimonialCreate;

export default function AddTestimonial() {
  const navigate = useNavigate();
  const [url, setUrl] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);

  const handleUrlChange = (e) => setUrl(e.target.value);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setThumbnail(file);
      setImagePreview(URL.createObjectURL(file));
    } else {
      setThumbnail(null);
      setImagePreview(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("url", url);
    // Append image files only if they are selected
    if (thumbnail) formData.append("thumbnail", thumbnail);

    try {
      await ApiRequest("POST", addTestimonialEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      navigate("/admin/testimonial");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Add Testimonial</h5>
      </div>
      <div className="add-blog-content">
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* url Input */}
            <div className="col-md-12">
              <label>Video URL (url of embedded link only):*</label>
              <input required type="text" value={url} onChange={handleUrlChange} className="form-control"/>
            </div>

            {/* Image Upload */}
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="thumbnail">Thumbnail (652 × 475 px)*</label>
                <input required type="file" className="form-control" id="thumbnail" onChange={handleImageChange}/>
                {imagePreview && (
                  <img src={imagePreview} alt="Preview" style={{ width: "100px", maxHeight: "300px",marginTop:"8px" }} />
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary submit-formbtn">
                Add Testimonial
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
